import React from 'react';

import Layout from './Shared/Layout';
import Cookies from 'universal-cookie';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Fade from 'react-bootstrap/Fade';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare } from '@fortawesome/free-regular-svg-icons';
import { faDownload, faArrowDown, faCheck, faLock } from '@fortawesome/free-solid-svg-icons';

import { scavengerList } from '../constants';

class ScavengerList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listComplete: false,
            domain: window.location.hostname === "localhost" || window.location.hostname === "athome.sfworks.xyz" ? "https://hunt.sfworks.xyz" : "https://hunt.sentai.com",
            dataUrl: "/scavenge/status.json",
            listData: {},
            emailFormSubmitted: false
        };
    }

    cookies = new Cookies();
    currentStep = 0;
    list = [];
    progressData = {};

    componentDidMount() {
        var me = this;

        setTimeout(function () {

            me.checkCookies();

        }, 250)

        // this.insertScript();

        window.scrollTo(0, 0);

        this.getData(this.state.domain + this.state.dataUrl);
    }

    checkCookies() {

        let hasCookie = this.cookies.get('emailFormSubmitted');

        if (hasCookie === true || hasCookie === "true") {

            this.setState({ emailFormSubmitted: true });
        } else {

            this.setState({ emailFormSubmitted: false });
        }

    }

    setCookie(val) {

        this.cookies.set('emailFormSubmitted', val, { path: '/', expires: "Mon, 20 Sep 2021 00:00:00 GMT" });
    }

    // insertScript() {

    //     const script = document.createElement("script");

    //     script.src = this.state.domain + "/scavenger/main.js";
    //     script.async = true;
    //     script.crossorigin = "anonymous"

    //     document.body.appendChild(script);
    // }

    postEmail() {

        if (!this.state.listComplete || this.state.emailFormSubmitted) return;

        let email = document.getElementById("email").value;

        let data = {
            email: email
        }

        fetch(this.state.domain + "/scavenge/email.json", {

            body: JSON.stringify(data),
            credentials: "include",
            method: "POST",

        }).then(response => {

            if (response.status === 200) {

                this.setCookie(true);
                this.setState({ emailFormSubmitted: true });

            } else {

                console.log("An Error Occurred...");

                console.log(response);

            }

            return response;

        })

    }

    displayLock() {

        if ((this.state.listComplete && !this.state.emailFormSubmitted)) {
            return (<></>)
        } else {
            return (
                <FontAwesomeIcon icon={faLock} style={{ fontSize: 24, color: "#505050", position: "absolute", left: "48%", top: 30, zIndex: 10, }} className="mr-2" />
            )
        }
    }

    handleChange(event) {

        this.setState({ email: event.target.value });
    }

    emailFocus() {

        document.getElementById("gachapon").style.display = "none";

    }

    emailBlur() {

        document.getElementById("gachapon").style.display = "block";

    }

    render() {
        return (
            <>
                <Layout className="position-relative">
                    <Fade in={true}>
                        <div className="pb-3 py-3 bg-darkPurple">
                            <Row className="justify-content-center">
                                <Col className="text-center">
                                    <img src="/ScavHunt_SAH_Logo_1000px.png" className="img-fluid" alt="Digital Gachapon - Scavenger Hunt" />
                                </Col>
                            </Row>
                            <Row>
                                <div className="col m-1 mt-1 mx-lg-5 my-lg-0 mt-lg-1">
                                    <p><strong className="text-green">IMPORTANT: Third-party cookies are required to participate. Some browsers block third-party (cross-site tracking) cookies, such as Safari and Chrome Incognito, which may block our scavenger hunt.</strong></p>
                                </div>
                            </Row>
                            <section className="rounded px-3 px-sm-3 py-5 m-1 mt-3 m-lg-5 mt-lg-3" style={{ border: "1px solid #96f500", position: "relative" }}>
                                <div className="text-center" style={{ position: "absolute", left: 0, right: 0, top: -12, zIndex: 10 }}>
                                    <span className="px-3 py-1 text-green" style={{ backgroundColor: "#0f0e17", }}>Enter to Win a $100 Sentai Gift Card</span>
                                </div>

                                <Row className="justify-content-center">
                                    <Col xs="12" md="11" lg="8">
                                        {this.renderCompleteFormText()}
                                        <InputGroup className="mb-0 pt-3 position-relative" size="lg">
                                            {this.displayLock()}
                                            <FormControl
                                                placeholder="Email Address..."
                                                aria-label="Email Address"
                                                disabled={(this.state.listComplete && !this.state.emailFormSubmitted) ? "" : "disabled"}
                                                className={(this.state.listComplete && !this.state.emailFormSubmitted) ? "" : "disabled"}
                                                id="email"
                                                onFocus={() => { this.emailFocus() }}
                                                onBlur={() => { this.emailBlur() }}
                                            />
                                            <InputGroup.Append>
                                                <Button variant="primary"
                                                    style={{ border: 0 }}
                                                    disabled={(this.state.listComplete && !this.state.emailFormSubmitted) ? "" : "disabled"}
                                                    onClick={() => { this.postEmail() }}
                                                >Enter!
                                                </Button>
                                            </InputGroup.Append>
                                        </InputGroup>
                                    </Col>
                                </Row>
                            </section>
                            <section className="rounded px-3 px-sm-3 py-5 m-1 mx-sm-3 mt-5 m-lg-5" style={{ border: "1px solid #96f500", position: "relative" }}>
                                <div className="text-center" style={{ position: "absolute", left: 0, right: 0, top: -12, zIndex: 10 }}>
                                    <span className="px-3 py-1 text-green" style={{ backgroundColor: "#0f0e17", }}>Digital Goodies</span>
                                </div>
                                <Row className="justify-content-center">
                                    <span className="d-block d-lg-inline col-12 col-lg-auto">
                                        <ul className="list-unstyled">
                                            {this.renderList()}
                                        </ul>
                                    </span>
                                </Row>
                                {this.renderClueHint()}
                            </section>
                            <section className="rounded px-3 px-sm-3 py-5 m-1 mt-5 m-lg-5" style={{ border: "1px solid #96f500", position: "relative" }}>
                                <div className="text-center" style={{ position: "absolute", left: 0, right: 0, top: -12, zIndex: 10 }}>
                                    <span className="px-3 py-1 text-green" style={{ backgroundColor: "#0f0e17", }}>Rules</span>
                                </div>
                                <Row className="justify-content-center">
                                    <Col xs="12" md="11" lg="8">
                                        <p>Hey anime fans!</p>
                                        <p>
                                            While you’re waiting for Sentai at Home to drop, we’ve dropped a few clues for you to find in the first-ever Sentai Scavenger Hunt.
                                        </p>
                                        <p>
                                            Clues have been hidden on sentaifilmworks.com, hidive.com and athome.sentai.com, but you’ll have to use your imagination and detective skills to evaluate the clues in order to know where to go next!
                                        </p>
                                        <p>
                                            Everyone who completes the scavenger hunt will unlock some exclusive digital goodies, and a few lucky scavengers will have a chance to win Sentai Shop digital gift cards!
                                        </p>
                                        <p>
                                            The scavenger hunt runs through the end of the Sentai at Home event (August 26th, 11:59 PM CDT). Please note that the scavenger hunt uses cookies, and cookies must be enabled in your browser to participate. To complete the scavenger hunt you must participate on the same browser and device. <strong>Disclaimer: The scavenger hunt is open to residents of the United States and Canada only</strong>.
                                        </p>
                                        <p>
                                            How to play:
                                        </p>
                                        <ol>
                                            <li className="pb-3">
                                                <img style={{ maxWidth: 90, float: 'right' }} src="/Clue_Capsule.png" className="img-fluid ml-3 mb-3 rounded border border-green" />
                                                Click the "Gachapon" capsule image at the bottom of this page. Don't see the Gatchapon, <a href="/#/scavenger-hunt">click here</a>
                                            </li>
                                            <li className="pb-3">
                                                You'll receive your first clue. Think you know where to go? Pull up the appropriate page in this web browser. Refresh this page to see your current unlocked prizes.
                                            </li>
                                            <li className="pb-3">
                                                If you are correct, you will find the Gachapon somewhere on the webpage. (No cheating! It won't appear until you've been given the clue.) Click the Gachapon to open and unlock a prize.

                                            </li>
                                            <li className="pb-3">
                                                Click the Gachapon again to unlock your next clue. Hmm, what page could it be on? Track it down, and keep going until you find all 8! If you lose your place come back to this page and refresh to view your current clue.
                                            </li>
                                            <li className="pb-3">
                                                Clues can appear on sentaifilmworks.com, hidive.com, and athome.sentai.com.  <strong className="text-green">IMPORTANT: Third-party cookies are required to participate. Some browsers block third-party (cross-site tracking) cookies, such as Safari and Chrome Incognito, which may block our scavenger hunt.</strong>
                                            </li>
                                            <li className="pb-3">
                                                Once you have solved all 8 clues, you will be able to access all of the digital prizes you have earned. Those who complete all 8 challenges can also enter their email address into a drawing for a chance to win a Sentai Store gift card. One entry per person. We are giving away one (1) $100 gift card, two (2) $50 gift cards, and ten (10) $10 gift cards. One random drawing the day after the event will determine the winners. Winners will be notified within seven days following the end of the event. Please note gift cards are non-transferable, not redeemable for cash and can only be used in the United States and Canada.
                                            </li>
                                            <li className="pb-3">
                                                That’s it! Get hunting!
                                            </li>
                                        </ol>

                                    </Col>
                                </Row>
                            </section>
                        </div>
                    </Fade>
                </Layout>
            </>
        )
    }


    renderList() {

        this.list = [];

        let domain = this.state.domain;
        let currentStep = 0;

        let result = this.state.listData;

        this.currentStep = currentStep = result.current;

        for (let i = 0; i < parseInt(currentStep); i++) {

            let item = scavengerList[i];
            let downloadPrize = domain + "/prize/" + (i + 1) + ".jpg";

            this.list.push(
                <li key={i} className="list-item mb-4 text-left">
                    <FontAwesomeIcon icon={faCheckSquare} style={{ fontSize: 24, color: "#96f500" }} className="mr-3" />
                    {item.label}<a className="pl-0 pl-sm-3" rel="noopener noreferrer" target="_blank" href={downloadPrize}><br className="d-block d-sm-none" />
                        <span className="d-block d-sm-inline pt-2 pt-sm-0 ml-5 ml-sm-0" style={{ textDecoration: 'none', fontWeight: 600 }}>
                            <FontAwesomeIcon icon={faDownload} style={{ fontSize: 18, color: "#96f500" }} className="mr-2" />Get It Here!
                        </span>
                    </a>
                </li>
            );
        }

        return this.list;
    }

    getData = async (dataPath) => {

        this.setState({ listData: {} });

        const response = await fetch(dataPath, { credentials: "include" });
        const json = await response.json();

        if (!this.state.listComplete && parseInt(json.current) === scavengerList.length) {
            this.setState({ listComplete: true });
        }

        this.setState({ listData: json });
    }

    renderClueHint() {

        if (this.list.length === 0) {

            return (
                <Row className="justify-content-center">
                    <Col xs={12} lg={8}>
                        <p className="text-center">
                            Once you start solving clues your prizes will be found here. Refresh this page to see your current unlocked prizes.
                        </p>
                        <p className="text-center text-green">
                            <FontAwesomeIcon icon={faArrowDown} style={{ color: "#96f500" }} className="mr-2" /> Your first clue is at the bottom-left of this page.
                        </p>
                    </Col>
                </Row>

            )

        } else if (!this.state.listComplete) {

            return (
                <Row className="justify-content-center mt-3" style={{ fontWeight: 600 }}>
                    <Col xs={12} lg={8} className="text-center">
                        <p className="text-center">
                            Once you start solving clues your prizes will be found here. Refresh this page to see your current unlocked prizes.
                        </p>
                        <p className="text-green">
                            <FontAwesomeIcon icon={faArrowDown} style={{ color: "#96f500" }} className="mr-2" /> Find your next clue at the bottom of this page...
                        </p>
                    </Col>
                </Row>
            )

        } else {

            return (
                <Row className="justify-content-center mt-3" style={{ fontWeight: 600 }}>
                    <Col className="text-green text-center">
                        <FontAwesomeIcon icon={faCheck} style={{ color: "#96f500" }} className="mr-2" /> List complete! Fill out the form above to enter!
                    </Col>
                </Row>
            )
        }
    }

    renderCompleteFormText() {

        if (this.state.emailFormSubmitted) {

            return (
                <>
                    <h2 className="h5 text-green text-center">Congratulations!</h2>
                    <p className="text-center">You have been entered for a chance to win a $100 Sentai gift card!</p>
                </>
            )

        } else if (this.state.listComplete) {

            return (
                <>
                    <h2 className="h5 text-green text-center">Scavenger hunt complete!</h2>
                    <p className="text-center">Submit your email address below for a chance to win a $100 Sentai gift card.</p>
                </>
            )

        } else {

            return (
                <>
                    <p>Complete the scavenger hunt list below by solving clues and unlock the form for a chance to win a $100 Sentai gift card.</p>
                </>
            )
        }
    }

}

export default ScavengerList;
